// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Textarea-module__root--zUOvc > textarea {
  box-sizing: border-box;
  position: relative;
  display: flex;
  width: 100%;
  height: 120px;
  align-items: flex-start;
  padding: 12px 16px;
  border: 1px solid var(--chaek-color-surface-subtle);
  border-radius: 15px;
  outline: 0;
  background-color: var(--chaek-color-surface-subtle);
  color: var(--chaek-color-text-primary);
  font-family: var(--chaek-font-family-gowun-dodum);
  font-size: 1rem;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.7625px;
}

.Textarea-module__root--zUOvc:focus-within {
  border-color: var(--chaek-color-border-strong);
}

.Textarea-module__root--zUOvc:has(> textarea:disabled) {
  opacity: 0.4;
}

.Textarea-module__root--zUOvc > textarea::placeholder {
  color: var(--chaek-color-text-placeholder);
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Textarea/Textarea.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,mDAAmD;EACnD,mBAAmB;EACnB,UAAU;EACV,mDAAmD;EACnD,sCAAsC;EACtC,iDAAiD;EACjD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,UAAU;AACZ","sourcesContent":[".root > textarea {\n  box-sizing: border-box;\n  position: relative;\n  display: flex;\n  width: 100%;\n  height: 120px;\n  align-items: flex-start;\n  padding: 12px 16px;\n  border: 1px solid var(--chaek-color-surface-subtle);\n  border-radius: 15px;\n  outline: 0;\n  background-color: var(--chaek-color-surface-subtle);\n  color: var(--chaek-color-text-primary);\n  font-family: var(--chaek-font-family-gowun-dodum);\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 24px;\n  letter-spacing: -0.7625px;\n}\n\n.root:focus-within {\n  border-color: var(--chaek-color-border-strong);\n}\n\n.root:has(> textarea:disabled) {\n  opacity: 0.4;\n}\n\n.root > textarea::placeholder {\n  color: var(--chaek-color-text-placeholder);\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Textarea-module__root--zUOvc`
};
export default ___CSS_LOADER_EXPORT___;
